export const colorList: string[] = [
    'primary',
    'red',
    'pink',
    'purple',
    'deep-purple',
    'indigo',
    'blue',
    'cyan',
    'teal',
    'green',
    'light-green',
    'lime',
    'amber',
    'orange',
    'deep-orange',
    'brown',
    'blue-grey',
    'grey'
]